import { createActionTypes } from 'utils/action/actionTypes';

export const FETCH_REPORT_LIST = createActionTypes('FETCH_REPORT_LIST');
export const FETCH_REPORT_DOWNLOAD_REQUEST = createActionTypes('FETCH_REPORT_DOWNLOAD_REQUEST');
export const GET_SIGNED_URL = createActionTypes('GET_SIGNED_URL');
export const CREATE_REPORT_DOWNLOAD_REQUEST = createActionTypes('CREATE_REPORT_DOWNLOAD_REQUEST');
export const GET_BULK_SIGNED_URL = createActionTypes('GET_BULK_SIGNED_URL');
export const GET_COMPANIES_BY_MODE = createActionTypes('GET_COMPANIES_BY_MODE');
export const FETCH_REPORT_KEY_LIST = createActionTypes('FETCH_REPORT_KEY_LIST');
export const FETCH_TENANTS_LIST = createActionTypes('FETCH_TENANTS_LIST');
